
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/integrations/nextjs",
      function () {
        return require("private-next-pages/material-ui/integrations/nextjs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/integrations/nextjs"])
      });
    }
  